module.exports = __webpack_public_path__ + "media/images/client-17-218b94e3b5edaae09b9f497250bbb357.png";